import { BarChart3 } from 'lucide-react';

export function ProgressSummaryCard({ completedModules, totalModules, overallPct }: {
  completedModules: number; totalModules: number; overallPct: number;
}) {
  return (
    <div className="flex items-center gap-4 rounded-[20px] border border-[#ececec] bg-white px-[21px] py-[17px] shadow-[0px_1px_4px_rgba(0,0,0,0.04)]">
      <span className="flex size-11 shrink-0 items-center justify-center rounded-2xl bg-[#ede9fe]">
        <BarChart3 className="size-5 text-[#8b5cf6]" />
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-[13px] font-semibold leading-[19.5px] text-[#6b7280]">Progress Summary</p>
        <p className="text-[15px] font-bold leading-[22.5px] text-[#111827]">{completedModules} of {totalModules} modules completed</p>
      </div>
      <div className="flex shrink-0 flex-col items-end gap-1.5">
        <span className="text-xl font-bold leading-7 text-[#111827]">{overallPct}%</span>
        <div className="h-2 w-[90px] rounded-full bg-[#ede9fe]">
          <div className="h-2 rounded-full" style={{ width: `${overallPct}%`, background: 'linear-gradient(to right, #8b5cf6, #c084fc)' }} />
        </div>
      </div>
    </div>
  );
}
